var _templateObject = _taggedTemplateLiteralLoose(['\n  padding: ', ';\n  border: ', ';\n  color: ', ';\n  background-color: ', ';\n  border-radius: 0;\n  min-width: 120px;\n  white-space: nowrap;\n  cursor: pointer;\n  text-transform: uppercase;\n  font-size: 12px;\n  ', '\n'], ['\n  padding: ', ';\n  border: ', ';\n  color: ', ';\n  background-color: ', ';\n  border-radius: 0;\n  min-width: 120px;\n  white-space: nowrap;\n  cursor: pointer;\n  text-transform: uppercase;\n  font-size: 12px;\n  ', '\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  padding: 15px 20px;\n  text-transform: uppercase;\n  font-weight: 400;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  text-decoration: none;\n  color: #fff;\n  background-color: ', ';\n  border-color: ', ';\n\n  &:hover {\n    cursor: pointer;\n    background-color: ', ';\n    border-color: ', ';\n  }\n'], ['\n  padding: 15px 20px;\n  text-transform: uppercase;\n  font-weight: 400;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  text-decoration: none;\n  color: #fff;\n  background-color: ', ';\n  border-color: ', ';\n\n  &:hover {\n    cursor: pointer;\n    background-color: ', ';\n    border-color: ', ';\n  }\n']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Button as RSButton } from 'reactstrap';
import Theme from '../../Theme';
import { lightBlue } from '../../assets/colors';

var ButtonDef = styled(RSButton)(_templateObject, function (props) {
  return props.outline && '13px 15px' || '15px 20px';
}, function (props) {
  return props.outline && 'solid 2px ' + lightBlue || 'none';
}, function (props) {
  return props.outline && lightBlue || 'white';
}, function (props) {
  return props.outline && 'transparent' || lightBlue;
}, function (_ref) {
  var fw = _ref.fw;
  return fw && 'width: 100%;';
});

var ButtonLinkDef = styled.a(_templateObject2, Theme.colors.lightBlue, Theme.colors.lightBlue, Theme.colors.blue, Theme.colors.blue);

ButtonLinkDef.displayName = 'ButtonLink';

ButtonDef.displayName = 'Button';

var ButtonDefinitionPropTypes = {
  outline: PropTypes.bool,
  fw: PropTypes.bool
};

ButtonDef.propTypes = ButtonDefinitionPropTypes;
ButtonLinkDef.propTypes = ButtonDefinitionPropTypes;

export var Button = ButtonDef;
export var ButtonLink = ButtonLinkDef;